import { Chips } from "primereact/chips";

const BaseInputChips = (props)=>{
    return <Chips {...props}></Chips>
}

export default BaseInputChips;